import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function RenewalPopup({ open, onClose, daysRemaining, onChoice }) {
  const nav = useNavigate();

  const choose = async (choice) => {
    try {
      const { data } = await api.post("/renewal/choice", { choice });
      if (choice === "yes") {
        toast.success("Proceed to payment to renew");
        nav("/seller/subscription", { state: { payment: data.payment } });
      } else if (choice === "later") {
        toast("Reminder saved. View-only access for remaining days.");
      } else {
        toast("Noted. You keep full access until your subscription expires.");
      }
      onChoice && onChoice(choice);
      onClose();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="renewal-popup">
        <div className="text-center">
          <div className="mx-auto h-14 w-14 rounded-full bg-amber-100 grid place-items-center mb-3">
            <AlertTriangle className="h-7 w-7 text-amber-600" />
          </div>
          <h2 className="font-heading text-xl font-extrabold">
            Your subscription expires in {daysRemaining <= 0 ? "less than a day" : `${daysRemaining} day${daysRemaining === 1 ? "" : "s"}`}.
          </h2>
          <p className="text-muted-foreground mt-2 text-sm">
            Would you like to continue your Cleartile subscription?
          </p>
          <div className="mt-6 space-y-2">
            <Button data-testid="renewal-popup-yes-btn" className="w-full font-bold" onClick={() => choose("yes")}>
              YES, CONTINUE
            </Button>
            <Button data-testid="renewal-popup-later-btn" variant="outline" className="w-full font-semibold" onClick={() => choose("later")}>
              LATER
            </Button>
            <Button data-testid="renewal-popup-no-btn" variant="ghost" className="w-full text-muted-foreground" onClick={() => choose("no")}>
              NO, DON'T CONTINUE
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
